<template>
  <div class="flex items-center justify-end gap-2 text-sm text-gray-600">
    <span class="tabular-nums">{{ pagerText({ page, pageSize, total }) }}</span>
    <button type="button" class="btn-secondary !px-3 !py-1" :disabled="page <= 1" @click="emit('page', page - 1)">Previous</button>
    <button type="button" class="btn-secondary !px-3 !py-1" :disabled="page * pageSize >= total" @click="emit('page', page + 1)">Next</button>
  </div>
</template>

<script setup lang="ts">
  import { pagerText } from '@/utils/poTracker';

  defineProps<{ page: number; pageSize: number; total: number }>();
  const emit = defineEmits<{ page: [page: number] }>();
</script>
